<template>
  <ParallelEditErrorModal></ParallelEditErrorModal>
  <TourCard v-if="order" :order="order" :index="1" :activeOrder="1"> </TourCard>
</template>
<script setup lang="ts">
import TourCard from "@/components/tours/TourCard.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";

const order = ref(null);

reAuthorize(store)
  .then((res) => store.dispatch("OrderStore/getTours"))
  .then((res) => {
    order.value = store?.state?.OrderStore?.tours.find(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
  });
const route = useRoute();
</script>
